/**
 * 頁頭的「API 檢視」開關（只有伺服器設 SRV_INSPECT=1 時才出現）。
 */
"use client";

import { ScanSearch } from "lucide-react";
import { useInspect } from "@/components/inspect/inspect-provider";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function InspectToggle() {
  const { available, on, toggle } = useInspect();
  if (!available) return null;
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={toggle}
      aria-pressed={on}
      data-inspect="shell.inspect"
      className={cn("text-white/80 hover:bg-white/10 hover:text-white", on && "bg-white/15 text-white")}
    >
      <ScanSearch />
      <span className="hidden sm:inline">API 檢視{on ? "：開" : ""}</span>
    </Button>
  );
}
